import React from 'react';
import { SEO } from '../lib/seo';
import { ContactForm } from '../components/ContactForm';

export function Contact({ settings }) {
  const phone = settings?.phone || "82 82 10 10";
  const email = settings?.email || "kontakt@fodtid.dk";
  const hours = settings?.hours || "Mandag - Lørdag: 9 - 18";
  const coverage = settings?.coverage_area || "Hele Sjælland – minus øerne";

  return (
    <>
      <SEO 
        title="Kontakt & Bestil Tid | Fodtid"
        description="Bestil en professionel udkørende fodbehandling i eget hjem. Ring 82 82 10 10 eller udfyld bestillingsformularen. Vi kører ud på hele Sjælland (minus øerne) man-lør 9-18."
      />

      {/* Header */}
      <section className="bg-canvas py-14 sm:py-18 border-b border-brand-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 text-center space-y-3">
          <span className="text-xs uppercase font-bold tracking-widest text-brand-charcoal bg-surface px-3.5 py-1 rounded-full border border-brand-border">
            Hurtig & Enkel Bestilling
          </span>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-brand-charcoal">
            Kontakt Fodtid
          </h1>
          <p className="text-brand-muted text-sm sm:text-base max-w-xl mx-auto leading-relaxed">
            Bestil tid i dag – så ses vi snart i dit eget hjem. Vi står klar til at hjælpe dig med professionel og omsorgsfuld fodpleje.
          </p>
        </div>
      </section>

      {/* Main Form & Info Section */}
      <section className="py-16 sm:py-24 bg-canvas border-b border-brand-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            
            {/* Left Contact Card & Info */}
            <div className="lg:col-span-5 space-y-8">
              
              <div className="space-y-3">
                <span className="text-xs uppercase font-bold tracking-widest text-brand-muted">
                  Må jeg hjælpe dig?
                </span>
                <h2 className="font-serif text-3xl font-bold text-brand-charcoal">
                  Klaus Just – Din mobile behandler
                </h2>
                <p className="text-brand-muted text-sm leading-relaxed">
                  Med over 15 års erfaring inden for fodpleje og zoneterapi bruger jeg de nyeste teknikker for at sikre dig de bedste resultater. Jeg behandler stort set alle typer fodproblemer og rådgiver gerne om det rette forløb.
                </p>
              </div>

              {/* Direct cards */}
              <div className="space-y-4">
                
                {/* Phone Card */}
                <div className="bg-surface/50 p-5 rounded-2xl border border-brand-border flex items-start gap-4 shadow-xs">
                  <div className="w-11 h-11 rounded-full bg-surface border border-brand-border text-brand-charcoal flex items-center justify-center text-base shrink-0">
                    <i className="fa-solid fa-phone text-brand-accent" aria-hidden="true" />
                  </div>
                  <div className="space-y-0.5">
                    <div className="text-[10px] font-bold text-brand-muted uppercase tracking-wider">Telefonisk henvendelse</div>
                    <a
                      href={`tel:${phone.replace(/\s+/g, '')}`}
                      className="text-base font-bold text-brand-charcoal hover:text-brand-accent whitespace-nowrap block"
                    >
                      {phone}
                    </a>
                    <div className="text-[11px] text-brand-muted">Ring gerne i tidsrummet 9:00 – 18:00</div>
                  </div>
                </div>

                {/* Email Card */}
                <div className="bg-surface/50 p-5 rounded-2xl border border-brand-border flex items-start gap-4 shadow-xs">
                  <div className="w-11 h-11 rounded-full bg-surface border border-brand-border text-brand-charcoal flex items-center justify-center text-base shrink-0">
                    <i className="fa-solid fa-envelope text-brand-accent" aria-hidden="true" />
                  </div>
                  <div className="space-y-0.5">
                    <div className="text-[10px] font-bold text-brand-muted uppercase tracking-wider">Skriftlig henvendelse</div>
                    <a
                      href={`mailto:${email}`}
                      className="text-sm font-bold text-brand-charcoal hover:text-brand-accent whitespace-nowrap block"
                    >
                      {email}
                    </a>
                    <div className="text-[11px] text-brand-muted">Vi besvarer typisk indenfor få timer</div>
                  </div>
                </div>

                {/* Hours & Area Card */}
                <div className="bg-surface/50 p-5 rounded-2xl border border-brand-border flex items-start gap-4 shadow-xs">
                  <div className="w-11 h-11 rounded-full bg-surface border border-brand-border text-brand-charcoal flex items-center justify-center text-base shrink-0">
                    <i className="fa-regular fa-clock text-brand-accent" aria-hidden="true" />
                  </div>
                  <div className="space-y-0.5">
                    <div className="text-[10px] font-bold text-brand-muted uppercase tracking-wider">Køretider & Område</div>
                    <div className="text-sm font-bold text-brand-charcoal">{hours}</div>
                    <div className="text-xs text-brand-muted font-medium">{coverage}</div>
                    <div className="text-[11px] text-brand-muted pt-1">
                      Kørsel altid inkluderet i postnumre 2000–2990
                    </div>
                  </div>
                </div>

              </div>

            </div>

            {/* Right Booking Webform */}
            <div className="lg:col-span-7 bg-surface/50 rounded-3xl p-6 sm:p-10 border border-brand-border shadow-xs">
              <div className="mb-6">
                <h3 className="font-serif text-2xl font-bold text-brand-charcoal mb-1">
                  Send en besked eller bestilling
                </h3>
                <p className="text-xs text-brand-muted">
                  Udfyld felterne herunder – vi bekræfter hurtigt din aftale.
                </p>
              </div>
              <ContactForm />
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
